<template>
  <div>
    <vue3-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="false"
      :paginate-elements-by-height="1000"
      filename="pt"
      :pdf-quality="2"
      :manual-pagination="true"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="700px"
      @progress="onProgress($event)"
      @hasStartedGeneration="hasStartedGeneration()"
      @hasGenerated="hasGenerated($event)"
      ref="html2Pdf"
      :html-to-pdf-options="htmlToPdfOptions"
    >
      <template v-slot:pdf-content>
        <div id="ptimpressao">
          <div class="row align-center">
            <div style="width: 15%" class="column justify-around top">
              <q-img
                crossorigin="*"
                v-if="$store.state.autenticacao.logo.logoImpressao"
                :src="$store.state.autenticacao.logo.logoImpressao"
              />
              <q-img
                crossorigin="*"
                v-else
                src="../../../../assets/MULTPEX_VETOR.png"
              />
            </div>

            <section class="column q-pl-md" style="width: 85%">
              <div class="border q-pl-sm text-bold">
                Nº da PT: <span class="text">{{ pt.ptId }}</span>
              </div>

              <div style="width: 100%" class="row">
                <div style="width: 50%" class="row">
                  <div style="width: 33.3%" class="column">
                    <span class="border-right">⠀⠀⠀⠀⠀⠀⠀⠀⠀</span>
                    <span
                      class="border-left-rigth q-pl-sm row justify-center text-bold"
                      >Emissão</span
                    >
                    <span
                      class="border-left-rigth q-pl-sm row justify-center text-bold"
                      >Prev. Início</span
                    >
                    <span
                      class="border-left-rigth q-pl-sm row justify-center text-bold"
                      >Prev. Término</span
                    >
                    <span v-if="pt.logStatus"
                      ><span
                        v-for="(status, index) in pt.logStatus"
                        :key="index"
                        class="border-left-rigth q-pl-sm row justify-center text-bold"
                        >{{ status.status == "aberto" ? "Em Aberto" : "" }}
                        {{
                          status.status == "aguardando_assinaturas"
                            ? "Em Ass."
                            : ""
                        }}
                        {{ status.status == "iniciado" ? "Iniciado" : ""
                        }}{{ status.status == "encerrado" ? "Encerrado" : "" }}
                        {{ status.status == "finalizado" ? "Finalizado" : "" }}
                        {{
                          status.status == "cancelado" ? "Cancelado" : ""
                        }}</span
                      >
                    </span>
                  </div>
                  <div style="width: 33.3%" class="column">
                    <span
                      class="border-left-rigth q-pl-sm row justify-center text-bold"
                      >Data</span
                    >
                    <span
                      v-if="pt.dataHoraEmissao"
                      class="border-left-rigth q-pl-sm"
                      >{{
                        pt.dataHoraEmissao
                          .split(" ")[0]
                          .split("-")
                          .reverse()
                          .join("/")
                      }}</span
                    >
                    <span
                      v-if="pt.dataHoraInicio"
                      class="border-left-rigth q-pl-sm"
                      >{{
                        pt.dataHoraInicio
                          .split(" ")[0]
                          .split("-")
                          .reverse()
                          .join("/")
                      }}</span
                    >
                    <span v-else class="border-left-rigth q-pl-sm"
                      >Sem Data</span
                    >
                    <span
                      v-if="pt.dataHoraTermino"
                      class="border-left-rigth q-pl-sm"
                      >{{
                        pt.dataHoraTermino
                          .split(" ")[0]
                          .split("-")
                          .reverse()
                          .join("/")
                      }}</span
                    >
                    <span v-else class="border-left-rigth q-pl-sm"
                      >Sem Data</span
                    >
                    <span v-if="pt.logStatus"
                      ><span
                        v-for="(status, index) in pt.logStatus"
                        :key="index"
                        class="border-left-rigth q-pl-sm row"
                        >{{
                          status.dataHora
                            .split(" ")[0]
                            .split("-")
                            .reverse()
                            .join("/")
                        }}</span
                      >
                    </span>
                  </div>
                  <div style="width: 33.4%" class="column">
                    <span
                      class="border-left-rigth q-pl-sm row justify-center text-bold"
                      >Hora</span
                    >
                    <span
                      v-if="pt.dataHoraEmissao"
                      class="border-left-rigth q-pl-sm"
                      >{{ pt.dataHoraEmissao.split(" ")[1] }}</span
                    >
                    <span
                      v-if="pt.dataHoraInicio"
                      class="border-left-rigth q-pl-sm"
                      >{{ pt.dataHoraInicio.split(" ")[1] }}</span
                    >
                    <span
                      v-if="pt.dataHoraTermino"
                      class="border-left-rigth q-pl-sm"
                      >{{ pt.dataHoraTermino.split(" ")[1] }}</span
                    >
                    <span v-else class="border-left-rigth q-pl-sm"
                      >Sem Data</span
                    >
                    <span v-if="pt.logStatus"
                      ><span
                        v-for="(status, index) in pt.logStatus"
                        :key="index"
                        class="border-left-rigth q-pl-sm row"
                        >{{ status.dataHora.split(" ")[1] }}</span
                      >
                    </span>
                  </div>
                </div>
                <div
                  style="width: 50%"
                  class="border-left-rigth q-pl-sm q-pt-md q-pb-md text-bold"
                >
                  Descrição do Trabalho:
                  <span class="text">{{ pt.descricao }}</span>
                </div>
              </div>

              <div style="width: 100%" class="row bottom">
                <span
                  style="width: 50%"
                  class="border-left-rigth q-pl-sm text-bold"
                  >Local: <span class="text">{{ pt.local }}</span></span
                >
                <span
                  style="width: 50%"
                  class="border-left-rigth q-pl-sm text-bold"
                  >Emissor: <span class="text">{{ pt.emissorNome }}</span></span
                >
              </div>
            </section>
          </div>
          <div class="row align-center q-pt-md">
            <div v-if="pt.informacoes" style="width: 100%" class="border">
              <p class="q-pt-sm q-pl-sm q-pr-sm q-pb-sm">
                <span class="text-bold">Observações Importantes:</span>
                {{ pt.informacoes.observacao }}
              </p>
            </div>

            <div
              style="width: 100%"
              class="row q-mt-sm"
              v-for="(ptData, index) in pt.respostasAtividades"
              :key="index"
            >
              <section style="width: 100%" class="column">
                <div class="border row justify-center bg-deep-purple-1">
                  <p class="row justify-center q-pl-sm text-bold">
                    {{ ptData.nome }}
                  </p>
                </div>
                <div class="row border-bottom">
                  <span class="q-pl-sm bg-grey-5 border-left" style="width: 80%"
                    >Descrição</span
                  >
                  <span
                    class="border-left border-right row justify-center"
                    style="width: 10%"
                    ><strong>SIM</strong></span
                  >
                  <span
                    class="border-right row justify-center"
                    style="width: 10%"
                    ><strong>N/A</strong></span
                  >
                </div>
                <div
                  class="row border-left"
                  v-for="(ptRespostas, index) in ptData.respostasPerguntas"
                  :key="index"
                >
                  <span class="q-pl-sm border-bottom" style="width: 80%">
                    {{ index }} - {{ ptRespostas.descricao }}
                    <span
                      v-if="ptRespostas.observacao"
                      class="row"
                      style="width: 80%"
                    >
                      <strong>Obs:</strong> {{ ptRespostas.observacao }}
                    </span></span
                  >

                  <span
                    class="border-left border-right border-bottom row justify-center align"
                    style="width: 10%"
                    ><p
                      style="font-size: 18px"
                      v-if="ptRespostas.resposta == true"
                    >
                      <strong>X</strong>
                    </p></span
                  >
                  <span
                    class="border-left border-right border-bottom row justify-center align"
                    style="width: 10%"
                    ><p
                      style="font-size: 18px"
                      v-if="ptRespostas.resposta == false"
                    >
                      <strong>X</strong>
                    </p></span
                  >
                </div>
              </section>
            </div>
          </div>
          <div style="page-break-after: always"></div>
          <div class="row align-center q-pt-md">
            <div
              v-if="pt.informacoes"
              style="width: 100%"
              class="border q-mt-md"
            >
              <p class="q-pt-sm q-pl-sm q-pr-sm q-pb-sm">
                <span class="text-bold">Área de Trabalho:</span>
                {{ pt.informacoes.areaTrabalho }}
              </p>
            </div>

            <div
              v-if="pt.informacoes"
              style="width: 100%"
              class="row justify-between q-mt-md"
            >
              <p
                style="width: 40%"
                class="q-pt-sm q-pl-sm q-pr-sm q-pb-sm border"
              >
                <span
                  ><span class="text-bold">Recomendações:</span>
                  {{ pt.informacoes.recomendacao }}</span
                >
              </p>

              <p
                style="width: 58%"
                class="q-pt-sm q-pl-sm q-pr-sm q-pb-sm border"
              >
                <span v-if="pt.informacoes"
                  ><span class="text-bold">Outras Medidas:</span>
                  {{ pt.informacoes.outrasMedidas }}</span
                >
              </p>
            </div>

            <div style="width: 100%" class="border q-mt-md">
              <p class="q-pt-sm q-pl-sm q-pr-sm q-pb-sm">
                <span class="text-bold">Observações:</span> As pessoas
                <span class="color">executantes</span> que assinam esta seção
                estão de acordo com as disposições previstas nesta permissão,
                compreendem as suas responsabilidades e garantem que vão
                <span class="text-bold">executar</span> as atividades.
              </p>
            </div>

            <section
              style="width: 100%"
              class="border bg-deep-purple-1 row justify-center q-mt-md"
            >
              <p class="text-bold">Pessoas Executantes</p>
            </section>

            <section
              style="width: 50%"
              class="column border-top border-right q-mt-md"
              v-for="(executante, index) in pt.executantes"
              :key="index"
            >
              <div class="row border-left border-bottom">
                <p
                  class="row align text-bold border-bottom q-pl-sm border-right bg-deep-purple-1"
                  style="width: 60%"
                >
                  <span class="row col-12 items-center">
                    <q-icon name="person" class="q-pr-sm" />
                    Nome:
                    <span class="q-pl-sm">{{ executante.nome }}</span>
                  </span>
                  <span class="row col-12 items-center">
                    <q-icon name="how_to_reg" class="q-pr-sm" />
                    Matricula:
                    <span class="q-pl-sm">{{ executante.matricula }}</span>
                  </span>
                  <span class="row col-12 items-center">
                    <q-icon name="business" class="q-pr-sm" />
                    Empresa:
                    <span class="q-pl-sm">{{ executante.empresa }}</span>
                  </span>
                </p>
                <p class="row align q-pl-sm text-bold" style="width: 40%">
                  Função: <span class="q-pl-sm">{{ executante.cargo }}</span>
                </p>
              </div>
              <span
                class="column"
                v-for="(assinatura, index) in executante.assinaturas"
                :key="index"
              >
                <p class="q-pl-sm border-left border-bottom text-bold get">
                  Ass PT: {{ assinatura.atividadeNome }}

                  <img
                    crossorigin="*"
                    v-if="assinatura.assinaturaTipo == 'manual'"
                    class="img q-pl-md"
                    @click="getImg"
                    :src="assinatura.assinatura"
                    alt=""
                  />
                  <span
                    v-else
                    class="text-bold column justify-center"
                    style="height: 70px"
                  >
                    <span>Assinado Eletrônicamente</span>
                  </span>
                </p>
              </span>
            </section>
          </div>
          <div style="page-break-after: always"></div>
          <section class="column">
            <div class="row align-center q-pt-md">
              <main
                style="width: 33%"
                class="column"
                v-for="(responsavel, index) in pt.responsaveis"
                :key="index"
              >
                <div style="width: 100%" class="row">
                  <div style="width: 85%" class="column">
                    <section
                      v-if="responsavel.assinaturas"
                      class="column justify-center align content"
                    >
                      <img
                        crossorigin="*"
                        v-if="
                          responsavel.assinaturas[0].assinaturaTipo == 'manual'
                        "
                        class="img"
                        @click="getImg"
                        :src="responsavel.assinaturas[0].assinatura"
                        alt=""
                      />
                      <div
                        v-else
                        class="text-bold column justify-center"
                        style="height: 70px"
                      >
                        <span>Assinado Eletrônicamente</span>
                      </div>
                    </section>
                    <p class="text-bold column justify-center align q-pt-md">
                      Assinatura ({{ responsavel.tipo }})
                    </p>
                  </div>
                </div>

                <div style="width: 100%" class="row">
                  <div style="width: 85%" class="column q-mt-lg">
                    <section class="column justify-center align content">
                      <p>
                        <q-icon name="person" class="q-pr-sm" /><strong
                          >Nome: </strong
                        >{{ responsavel.nome }}
                      </p>
                      <p>
                        <q-icon name="how_to_reg" class="q-pr-sm" /><strong
                          >Matricula: </strong
                        >{{ responsavel.matricula }}
                      </p>
                      <p>
                        <q-icon name="business" class="q-pr-sm" /><strong
                          >Empresa: </strong
                        >{{
                          responsavel.tipo == "emissor"
                            ? pt.empresa
                            : responsavel.empresa
                        }}
                      </p>
                    </section>
                  </div>
                </div>
              </main>
            </div>

            <div class="border q-mt-md">
              <p v-if="pt.informacoes" class="q-pt-sm q-pl-sm q-pr-sm q-pb-sm">
                <span class="color">AVISO!</span> {{ pt.informacoes.aviso }}
              </p>
            </div>

            <div style="width: 100%" class="row justify-between q-mt-md">
              <p
                style="width: 100%"
                class="q-pt-sm q-pl-sm q-pr-sm q-pb-sm border"
              >
                <span
                  ><strong
                    >Cancelamento da permissão de trabalho (Razões e ações
                    necessárias):</strong
                  >{{
                    pt.detalhesCancelamento
                      ? pt.detalhesCancelamento.acoesNecessarias
                      : ""
                  }}</span
                >
              </p>
              <p
                style="width: 100%; margin-top: 10px"
                class="q-pt-sm q-pl-sm q-pr-sm q-pb-sm border"
              >
                <span
                  ><strong
                    >Cancelamento da permissão de trabalho (Observação):</strong
                  >
                  {{
                    pt.detalhesCancelamento
                      ? pt.detalhesCancelamento.observacao
                      : ""
                  }}</span
                >
              </p>
              <p
                style="width: 100%; margin-top: 10px"
                class="q-pt-sm q-pl-sm q-pr-sm q-pb-sm border"
              >
                <span
                  ><strong
                    >Cancelamento da permissão de trabalho (Motivo):</strong
                  >
                  {{
                    pt.detalhesCancelamento
                      ? pt.detalhesCancelamento.motivo
                      : ""
                  }}</span
                >
              </p>
              <p
                style="width: 100%; margin-top: 10px"
                class="q-pt-sm q-pl-sm q-pr-sm q-pb-sm border"
              >
                <span
                  ><strong>Observações de encerramento: </strong>
                  <span>{{ pt.obsEncerramento }}</span></span
                >
              </p>
            </div>

            <div style="width: 100%" class="row q-pt-md">
              <section style="width: 100%" class="column">
                <div class="row border-bottom">
                  <span
                    class="row justify-center text-bold q-pl-sm bg-grey-5 border-left border-top"
                    style="width: 80%"
                    >Encerramento</span
                  >
                  <span
                    class="border-left border-right row justify-center border-top"
                    style="width: 10%"
                    ><Strong>SIM</Strong></span
                  >
                  <span
                    class="border-right row justify-center border-top"
                    style="width: 10%"
                    ><Strong>N/A</Strong></span
                  >
                </div>
                <div
                  class="row border-left"
                  v-for="(ptData, index) in pt.respostasEncerramento"
                  :key="index"
                >
                  <span class="q-pl-sm border-bottom" style="width: 80%">
                    {{ ptData.pergunta }}
                  </span>
                  <span
                    class="border-left border-right border-bottom row justify-center align"
                    style="width: 10%"
                    ><p style="font-size: 18px" v-if="ptData.resposta == true">
                      <strong>X</strong>
                    </p></span
                  >
                  <span
                    class="border-left border-right border-bottom row justify-center align"
                    style="width: 10%"
                    ><p style="font-size: 18px" v-if="ptData.resposta == false">
                      <strong>X</strong>
                    </p></span
                  >
                </div>
              </section>
            </div>

            <div class="row align-center q-pt-md">
              <main
                style="width: 33%"
                class="column"
                v-for="(responsavel, index) in pt.responsaveis"
                :key="index"
              >
                <div style="width: 100%" class="row">
                  <div
                    v-if="responsavel.assinaturas"
                    style="width: 85%"
                    class="column"
                  >
                    <section
                      v-if="
                        responsavel.assinaturas[1]
                          ? responsavel.assinaturas[1].atividadeNome ==
                            'encerramento'
                          : ''
                      "
                      class="column justify-center align content"
                    >
                      <img
                        crossorigin="*"
                        v-if="
                          responsavel.assinaturas[1].assinaturaTipo == 'manual'
                        "
                        class="img"
                        @click="getImg"
                        :src="responsavel.assinaturas[1].assinatura"
                        alt=""
                      />
                      <div
                        v-else
                        class="text-bold column justify-center"
                        style="height: 70px"
                      >
                        <span>Assinado Eletrônicamente</span>
                      </div>
                    </section>
                    <p class="text-bold column justify-center align q-pt-md">
                      Assinatura ({{ responsavel.tipo }})
                    </p>
                  </div>
                </div>

                <div style="width: 100%" class="row">
                  <div style="width: 85%" class="column q-mt-lg">
                    <section class="column justify-center align content">
                      <p>
                        <q-icon name="person" class="q-pr-sm" /><strong
                          >Nome: </strong
                        >{{ responsavel.nome }}
                      </p>
                      <p>
                        <q-icon name="how_to_reg" class="q-pr-sm" /><strong
                          >Matricula: </strong
                        >{{ responsavel.matricula }}
                      </p>
                      <p>
                        <q-icon name="business" class="q-pr-sm" /><strong
                          >Empresa: </strong
                        >{{
                          responsavel.tipo == "emissor"
                            ? pt.empresa
                            : responsavel.empresa
                        }}
                      </p>
                    </section>
                  </div>
                </div>
              </main>
            </div>
          </section>
          <div style="page-break-after: always"></div>
          <div
            v-if="pt.observacoes || pt.obsAvaliacaoRisco"
            style="width: 100%"
            class="row q-mt-md"
          >
            <section style="width: 100%" class="column">
              <div class="border row justify-center bg-deep-purple-1">
                <p
                  class="row justify-center q-pl-sm text-bold"
                  style="font-size: 14px"
                >
                  Histórico de Observações
                </p>
              </div>
              <div class="row border-bottom">
                <span
                  class="q-pl-sm bg-grey-5 border-left text-bold justify-center row items-center"
                  style="width: 70%; font-size: 13px"
                  >Observação</span
                >
                <span
                  class="border-left border-right bg-grey-5 nome-responsavel row justify-center items-center"
                  style="width: 15%; font-size: 12px"
                  ><strong>Responsável</strong></span
                >
                <span
                  class="border-left border-right row bg-grey-5 justify-center items-center"
                  style="width: 15%; font-size: 12px"
                  ><strong>Data</strong></span
                >
              </div>
              <div v-if="pt.obsAvaliacaoRisco" class="row border-left">
                <span class="q-pl-sm border-bottom" style="width: 70%">
                  <span class="row col-12 q-pt-md">
                    <strong class="q-mr-xs">Status - Em Aberto: </strong>
                    {{ pt.obsAvaliacaoRisco }}
                  </span></span
                >
                <span
                  class="border-left border-right border-bottom row justify-center items-center"
                  style="width: 15%"
                  ><span style="font-size: 9px">
                    <strong>{{ pt.emissorNome }}</strong>
                  </span></span
                >
                <span
                  class="border-left border-right border-bottom row justify-center"
                  style="width: 15%"
                  ><span style="font-size: 9px"> <strong></strong> </span
                ></span>
              </div>
              <span v-if="pt.observacoes">
                <div
                  v-for="(observacao, index) in pt.observacoes"
                  :key="index"
                  class="row border-left"
                >
                  <span class="q-pl-sm border-bottom" style="width: 70%">
                    <span class="row col-12 q-py-md">
                      <strong class="q-mr-xs"
                        >Status -
                        {{
                          observacao.ptStatus == "aguardando_assinaturas"
                            ? "Em Ass.:"
                            : ""
                        }}{{
                          observacao.ptStatus == "iniciado" ? "Iniciado:" : ""
                        }}{{
                          observacao.ptStatus == "encerrado" ? "Encerrado:" : ""
                        }}
                        {{
                          observacao.ptStatus == "cancelado" ? "Cancelado:" : ""
                        }}</strong
                      >
                      {{ observacao.observacao }}
                    </span></span
                  >

                  <span
                    class="border-left border-right border-bottom row justify-center items-center"
                    style="width: 15%"
                    ><span style="font-size: 9px">
                      <strong>{{ pt.emissorNome }}</strong>
                    </span></span
                  >
                  <span
                    class="border-left border-right border-bottom items-center row justify-center"
                    style="width: 15%"
                    ><span style="font-size: 9px"
                      ><p>{{ observacao.dataHora.split(" ")[0] }}</p>
                      <span style="margin-left: 8px">{{
                        observacao.dataHora.split(" ")[1]
                      }}</span>
                      <strong></strong> </span
                  ></span>
                </div>
              </span>
            </section>
          </div>
        </div>
      </template>
    </vue3-html2pdf>
  </div>
</template>

<script>
import Vue3Html2pdf from "vue3-html2pdf";

export default {
  props: ["pt", "gerarPdf"],
  data() {
    return {
      htmlToPdfOptions: {
        margin: 10,
        filename: `permissaodetrabalho${this.pt.ptId}`,
        "pdf-quality": "2",
        html2canvas: {
          dpi: 100,
          letterRendering: true,
          useCORS: true,
        },
      },
    };
  },
  methods: {
    generateReport() {
      try {
        this.$refs.html2Pdf.generatePdf();
      } catch (error) {
        console.log(error);
      }
    },
    onProgress(event) {
      console.log(event);
    },
    hasGenerated(event) {
      console.log(event);
    },
  },
  watch: {
    gerarPdf() {
      this.generateReport();
    },
  },

  components: {
    Vue3Html2pdf,
  },
};
</script>

<style scoped>
.border {
  border: 1px solid black;
}

.border-left-rigth {
  border-left: 1px solid black;
  border-right: 1px solid black;
  border-bottom: 1px solid black;
}

.border-right {
  border-right: 1px solid black;
  border-bottom: 1px solid black;
}

.flex {
  display: flex;
  justify-content: center;
}

.top p {
  margin: 0;
  font-size: 7px;
}

p {
  font-size: 12px;
}

.text {
  font-weight: normal;
}

p {
  margin: 0;
}

.border {
  border: 1px solid black;
}

.border-left {
  border-left: 1px solid black;
}

.border-top {
  border-top: 1px solid black;
}

.border-right {
  border-right: 1px solid black;
}

.align {
  align-items: center;
}

.border-bottom {
  border-bottom: 1px solid black;
}

.flex {
  display: flex;
  justify-content: center;
}

.top p {
  margin: 0;
  font-size: 7px;
}

p {
  font-size: 12px;
}

.color {
  color: red;
}

p,
span {
  margin: 0;
}

img {
  width: 70px;
  height: 70px;
}

.border {
  border: 1px solid black;
}

.border-left {
  border-left: 1px solid black;
}

.border-top {
  border-top: 1px solid black;
}

.border-right {
  border-right: 1px solid black;
}

.align {
  align-items: center;
}

.border-bottom {
  border-bottom: 1px solid black;
}

.flex {
  display: flex;
  justify-content: center;
}

.top p {
  margin: 0;
  font-size: 7px;
}

p {
  font-size: 12px;
}

.color {
  color: red;
}
p,
span {
  margin: 0;
}

.content {
  border-bottom: 4px solid gray;
  border-radius: 2px;
}

.img {
  width: 70px;
  height: 70px;
}

.border {
  border: 1px solid black;
}

.border-left {
  border-left: 1px solid black;
}

.border-top {
  border-top: 1px solid black;
}

.border-right {
  border-right: 1px solid black;
}

.align {
  align-items: center;
}

.border-bottom {
  border-bottom: 1px solid black;
}

.flex {
  display: flex;
  justify-content: center;
}

.top p {
  margin: 0;
  font-size: 7px;
}

p {
  font-size: 12px;
}

.color {
  color: red;
}

.text {
  font-weight: normal;
}
</style>
